import { Box, Typography } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

/**
 * EmptyState — friendly placeholder for empty lists/tables/results.
 *
 * @param {ReactNode} [icon]        — MUI icon element (defaults to inbox)
 * @param {string}    title         — Short headline
 * @param {string}    [description] — Supporting copy
 * @param {ReactNode} [action]      — Optional CTA button
 * @param {boolean}   [compact]     — Tighter vertical padding for in-card use
 * @param {object}    [sx]          — Root overrides
 */
const EmptyState = ({ icon, title, description, action, compact, sx }) => (
  <Box sx={{ textAlign: 'center', py: compact ? 3 : 7, px: 2, ...sx }}>
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: compact ? 40 : 52,
        height: compact ? 40 : 52,
        borderRadius: '50%',
        bgcolor: 'action.hover',
        color: 'text.secondary',
        mb: 1.25,
        '& .MuiSvgIcon-root': { fontSize: compact ? 20 : 26 },
      }}
    >
      {icon || <InboxOutlinedIcon />}
    </Box>
    <Typography variant="subtitle1" fontWeight={600}>{title}</Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: 420, mx: 'auto' }}>
        {description}
      </Typography>
    )}
    {action && <Box sx={{ mt: 2 }}>{action}</Box>}
  </Box>
);

export default EmptyState;
